import type { FunctionComponent } from 'react';

import type { TabProps } from './types';

export const Tabs: FunctionComponent<TabProps> = ({ tabs, containerClassname, activeTabIndex, setActiveTabIndex, titleSize }) => {
  return (
    <div className={`relative w-full h-full mx-auto ${containerClassname}`}>
      <div className='flex gap-10'>
        {tabs.map((tab, i) => (
          <div
            key={i}
            className={`relative flex items-center justify-between py-1 mb-2 px-0.5 gap-2 cursor-pointer text-lg ${titleSize} ${i === activeTabIndex ? 'font-medium text-dark leading-6' : 'text-n500_light_text'}`}
            onClick={() => setActiveTabIndex(i)}
          >
            {tab.icon && <span>{tab.icon}</span>}
            <span className={`dark:text-n700_text_dark_mode ${titleSize}`}>{tab.title}</span>
            {i === activeTabIndex && <div className='absolute bottom-0 left-0 w-full h-1 bg-brand rounded-lg' />}
          </div>
        ))}
      </div>
      <div>{tabs[activeTabIndex].content}</div>
    </div>
  );
};
